import { css } from "@compiled/react";
import { useIntl } from "react-intl";

const getInlineLogosProp = [
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:4cba45db-e328-4abd-88ea-bfe276355cb5/Square%20Logo.svg",
        alt: "Square Logo"
    },
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:db51d228-2145-498b-ab73-064aa651770d/ebay%20logo.svg?cdnVersion=ecc",
        alt: "eBay logo"
    },
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:7db3e103-186c-4413-950d-dea2f2a5755c/Spotify%20logo.svg?cdnVersion=ecc",
        alt: "Spotify logo"
    },
    {
        src: "https://wac-cdn.atlassian.com/dam/jcr:4d6ede5b-a9ea-410b-baab-6cb7166c080d/Cisco%20Logo.svg?cdnVersion=ecc",
        alt: "Cisco logo"
    }
];

const customerSectionStyles = css({
    "justifyContent": "center",
    "alignItems": "center",
    "textAlign": "center",
    "padding": "64px 0px",

    "@media only screen and (max-width: 767.98px)": {
        paddingBlockStart: "16px",
        paddingBlockEnd: "16px"
    }
});

const h3Styles = css({
    "fontSize": "24px",
    "lineHeight": "32px",
    "fontWeight": "500",
    "color": "#253858",
    "padding": "16px",
    "margin-block": "unset",

    "@media only screen and (max-width: 767.98px)": {
        fontSize: "20px",
        lineHeight: "20px"
    }
});

const containerStyles = css({
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "gap": "0px 40px",
    "alignItems": "stretch",
    "textAlign": "center",
    "flexWrap": "nowrap",
    "marginLeft": "auto",
    "marginRight": "auto",
    "maxWidth": "1050px",
    "padding": "16px",

    "@media only screen and (max-width: 767.98px)": {
        flexDirection: "column",
        alignItems: "center",
        padding: "0"
    }
});

const imageStyles = css({
    "@media only screen and (max-width: 767.98px)": {
        margin: "16px",
        maxHeight: "49px"
    }
});

const SocialProofPaidLpJswFeatures = () => {
    const intl = useIntl();
    return (
        <section css={customerSectionStyles}>
            <h3 css={h3Styles}>
                {intl.formatMessage({
                    id: "JiraSoftwarePageTemplate.paidLpJswFeatures.customerSection.trustedByCustomersWorldWide",
                    defaultMessage:
                        "Trusted by over 100,000 customers world-wide"
                })}
            </h3>
            <div css={containerStyles}>
                {getInlineLogosProp.map((inlineLogo, index) => (
                    <img
                        key={index}
                        src={inlineLogo.src}
                        alt={inlineLogo.alt}
                        css={imageStyles}
                    />
                ))}
            </div>
        </section>
    );
};

export default SocialProofPaidLpJswFeatures;
